import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import { browserHistory } from 'react-router'
import styles from './styles'

export default class Survey extends Component {

  constructor(props) {
    super(props)
    this.state =
    {
      current: this.props.firstPanel,
      previous: [],
    }
  }

  @autobind change(component) {
    let previous = this.state.previous
    previous.push(this.state.current)
    let current = component
    this.setState({ current, previous })
  }

  @autobind goBack(event) {
  if (!this.state.previous.length) {
    browserHistory.push('/')
  } else {
    let previous = this.state.previous
    let current = previous.pop()
    this.setState({ previous, current })
  }
}

  render() {
    const Comp = this.state.current
    const backgroundImg = 'url('+ this.props.backgroundImg + ')'
    console.log(backgroundImg);
    return (
      <div className={styles.wrapper} style={{ backgroundImage: backgroundImg }}>
        <Comp {...this.props} change={this.change} goBack={this.goBack} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/Survey.js
 **/